import { FieldPath, FieldPathValue, useWatch } from '@jucy-ui/forms';
import { SearchFormValues } from '../types/SearchFormValues';

export const useSearchFormFieldValue = <TFieldName extends FieldPath<SearchFormValues>>(
    key: TFieldName
): FieldPathValue<SearchFormValues, TFieldName> => useWatch({ name: key });
